import { GrafosSymbol, LineStyle } from "../interfaces/element";
export const createGraphElement = (title, colX, colY, file = null, showLine = true, showSymbol = true, color = "black") => {
    return {
        colX,
        colY,
        colZ: "",
        file: file,
        fillSymbol: true,
        lineStyle: LineStyle.solid,
        lineWidth: showLine ? 1 : 0,
        symbol: showSymbol ? GrafosSymbol.circle : GrafosSymbol.none,
        symbolColor: color,
        symbolSize: 2,
        title,
    };
};
export const setElementColor = (element, color) => {
    return Object.assign(Object.assign({}, element), { symbolColor: color });
};
//# sourceMappingURL=element.js.map